export default{
    state: {
        agendamentoRealizado:{
           start: 'temp',
           barbeiro: 'temp',

          }
    },
    mutations: {
        addAgendamento(state, agendamento){
            state.agendamentoRealizado.start = agendamento.start;
            state.agendamentoRealizado.barbeiro = agendamento.barbeiro.nome;
        }
    },
    actions: {
        addAgendamento({commit}, agendamento){
            commit('addAgendamento', agendamento)
        }
    },
    getters: {
        agendamento(state){
            return state.agendamentoRealizado
        }
    }
}